<div class="kanban-page">
  <ng-container *ngIf="usaKanban; else kanbanDisabled">
  <div class="kanban-header">
    <div>
      <h1>CRM</h1>
    </div>

    <div class="kanban-actions">
      <div class="kanban-client-filter">
        <input
          class="form-control"
          [(ngModel)]="filtroClienteKanban"
          (ngModelChange)="aplicarFiltroCliente()"
          placeholder="Buscar cliente no CRM" />
      </div>
      <input
        class="form-control kanban-id-filter"
        type="number"
        [(ngModel)]="filtroIdKanban"
        (ngModelChange)="aplicarFiltroCliente(false)"
        placeholder="ID" />
      <select class="form-control kanban-filter-select" [(ngModel)]="filtroFormularioKanban" (ngModelChange)="aplicarFiltroCliente(false)">
        <option [ngValue]="null">Todos formularios</option>
        <option *ngFor="let formulario of formulariosDoDepartamento()" [ngValue]="formulario.id">{{ formulario.nome }}</option>
      </select>
      <select class="form-control kanban-filter-select" [(ngModel)]="filtroSellerKanban" (ngModelChange)="aplicarFiltroCliente(false)">
        <option [ngValue]="null">Todos vendedores</option>
        <option *ngFor="let seller of sellersFiltroKanban" [ngValue]="seller.id">{{ seller.fullname }}</option>
      </select>
      <select class="form-control kanban-filter-select" [(ngModel)]="filtroFechamentoKanban" (ngModelChange)="aplicarFiltroCliente(false)">
        <option value="">Todas datas</option>
        <option value="ATRASADA">Atrasada</option>
        <option value="HOJE">Hoje</option>
        <option value="FUTURA_7">Fecha em ate 7 dias</option>
        <option value="FUTURA_MAIS_7">Fecha em mais de 7 dias</option>
      </select>
      <button class="btn btn-outline-secondary" type="button" (click)="limparFiltroCliente()" *ngIf="filtroClienteKanban || filtroClienteIdKanban || filtroIdKanban || filtroFormularioKanban || filtroSellerKanban || filtroFechamentoKanban">Limpar</button>
      <button class="btn btn-outline-primary" type="button" (click)="abrirDashboard()">Dashboard</button>
      <button class="btn btn-outline-success" type="button" (click)="abrirImportacao()" [disabled]="!departamentoSelecionado">Importar Excel</button>
      <button class="btn btn-outline-secondary" (click)="carregar()">Atualizar</button>
      <button class="btn btn-primary" (click)="abrirNovo()" [disabled]="!departamentoSelecionado">Novo Card</button>
    </div>
  </div>

  <div class="department-tabs" *ngIf="board.departamentos.length > 0">
    <button
      *ngFor="let departamento of board.departamentos"
      class="department-tab"
      [class.active]="departamentoSelecionado && departamentoSelecionado.id === departamento.id"
      (click)="selecionarDepartamento(departamento)">
      {{ departamento.nome }}
    </button>
  </div>

  <div class="kanban-empty" *ngIf="!carregando && board.departamentos.length === 0">
    Nenhum departamento vinculado ao seu usuario.
  </div>

  <div
    #kanbanBoard
    class="kanban-board"
    [class.kanban-board-grabbing]="boardArrastando"
    *ngIf="departamentoSelecionado"
    (mousedown)="iniciarArrasteBoard($event)"
    (mousemove)="moverArrasteBoard($event)"
    (mouseup)="finalizarArrasteBoard()"
    (mouseleave)="finalizarArrasteBoard()">
    <section
      class="kanban-column"
      [ngClass]="classeBordaTipoEtapa(etapa)"
      *ngFor="let etapa of departamentoSelecionado.etapas"
      dndEffectAllowed="move"
      (dndDrop)="onDrop($event, etapa)"
      dndDropzone>
      <div class="column-header">
        <div>
          <div class="column-type" [ngClass]="classeTipoEtapa(etapa)">
            {{ textoTipoEtapa(etapa) }}
          </div>
          <span>{{ etapa.nome }}</span>
        </div>
        <strong>{{ etapa.negocios.length }}</strong>
      </div>

      <div class="kanban-column-body">
        <div class="kanban-placeholder" dndPlaceholderRef></div>

        <article
          class="deal-card"
          *ngFor="let negocio of negociosVisiveis(etapa)"
          [dndDraggable]="negocio"
          [dndEffectAllowed]="'move'"
          (dndStart)="onDragStart($event, negocio)"
          (dndMoved)="onDragged(negocio, etapa.negocios, 'move')"
          (dndCopied)="onDragged(negocio, etapa.negocios, 'copy')"
          (dndLinked)="onDragged(negocio, etapa.negocios, 'link')"
          (dndCanceled)="onDragged(negocio, etapa.negocios, 'none')"
          (dndEnd)="onDragEnd($event)"
          [class.deal-card-dragging]="negocioArrastandoId === negocio.id"
          (click)="abrirDetalhe(negocio)">
          <div class="deal-card-top">
            <div class="deal-age" [ngClass]="classeTempoAberto(negocio)">{{ textoTempoAberto(negocio) }}</div>
            <div class="deal-id-tag">ID: {{ negocio.id }}</div>
          </div>
          <div class="deal-title">{{ negocio.nome_negocio }}</div>
          <div class="form-type-tag card-form-tag" *ngIf="negocio.formulario_tipo_nome">{{ negocio.formulario_tipo_nome }}</div>
          <div class="deal-client">{{ negocio.cliente_nome }}<span *ngIf="negocio.codigo_no_erp_do_cliente"> [{{ negocio.codigo_no_erp_do_cliente }}]</span></div>
          <div class="deal-meta">
            <span>{{ negocio.seller_responsavel_nome }}</span>
            <span *ngIf="negocio.valor_negociacao">{{ negocio.valor_negociacao | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
          </div>
          <div class="deal-note" *ngIf="negocio.ultima_anotacao">{{ negocio.ultima_anotacao }}</div>
          <div class="deal-schedule" *ngIf="negocio.ligacao_agendada_id">
            <span>Ligacao agendada hoje {{ negocio.ligacao_agendada_data | date:'HH:mm' }}</span>
            <button type="button" (click)="abrirLigacaoAgendadaCard($event, negocio)">Ligar</button>
          </div>
          <div class="deal-close-tag" *ngIf="negocio.data_fechamento_prevista" [ngClass]="classeFechamento(negocio)">
            {{ textoFechamento(negocio) }}
          </div>
          <div class="deal-date" *ngIf="negocio.data_fechamento_prevista">Fechamento: {{ negocio.data_fechamento_prevista | date:'dd/MM/yyyy' }}</div>
        </article>

        <button type="button" class="load-more-cards" *ngIf="temMaisCards(etapa)" (click)="carregarMaisCards(etapa, $event)">
          Carregar mais 20
        </button>
      </div>
    </section>
  </div>

  <div class="side-panel" *ngIf="novoAberto">
    <div class="side-panel-header">
      <h2>Novo Card</h2>
      <button type="button" class="close-button" (click)="fecharNovo()">x</button>
    </div>

    <div class="form-group" *ngIf="formulariosDoDepartamento(novo.departamento_id).length > 1">
      <label>Tipo de formulario</label>
      <select class="form-control" [(ngModel)]="novo.formulario_tipo_id" (ngModelChange)="selecionarFormularioNovo()">
        <option [ngValue]="null">Selecione...</option>
        <option *ngFor="let formulario of formulariosDoDepartamento(novo.departamento_id)" [ngValue]="formulario.id">{{ formulario.nome }}</option>
      </select>
    </div>

    <div class="form-type-tag" *ngIf="novo.formulario_tipo_id">
      {{ formularioNome(novo.formulario_tipo_id, novo.departamento_id) }}
    </div>

    <div class="dynamic-form" *ngIf="novo.formulario_tipo_id">
      <div class="form-group" *ngFor="let campo of camposNovo()">
        <label>{{ campo.nome }} <span *ngIf="campo.obrigatorio">*</span></label>

        <ng-container [ngSwitch]="campo.chave">
          <input *ngSwitchCase="'nome_negocio'" class="form-control" [(ngModel)]="formularioValoresNovo[campo.id]" (ngModelChange)="campoFormularioAlterado(campo)" [placeholder]="campo.placeholder" maxlength="200" />

          <div *ngSwitchCase="'client_id'">
            <div class="client-search-row">
              <input class="form-control" [(ngModel)]="buscaCliente" (keyup.enter)="buscarClientes()" [placeholder]="campo.placeholder || 'Buscar cliente'" />
              <button type="button" class="btn btn-primary" (click)="buscarClientes()">Buscar</button>
            </div>

            <div class="client-box mt-2" *ngIf="novo.client_id">
              <div class="client-box-header">
                <div>
                  <small>Cliente selecionado</small>
                  <strong>{{ novo.cliente_nome }}</strong>
                </div>
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="trocarClienteSelecionado()">Trocar cliente</button>
              </div>
              <div class="grid-2">
                <label>Responsavel<input class="form-control" [(ngModel)]="novo.responsible_name" /></label>
                <label>Contato Call Center<input class="form-control" [(ngModel)]="novo.contato_callcenter" /></label>
                <label>Telefone<input class="form-control" [(ngModel)]="novo.phone" /></label>
                <label>Telefone 2<input class="form-control" [(ngModel)]="novo.fone_02" /></label>
                <label>Telefone 3<input class="form-control" [(ngModel)]="novo.fone_03" /></label>
                <label>WhatsApp DDD<input class="form-control" [(ngModel)]="novo.fone_whatss_ddd" /></label>
                <label>WhatsApp<input class="form-control" [(ngModel)]="novo.fone_whatss" /></label>
              </div>
            </div>
          </div>

          <select *ngSwitchCase="'seller_id_responsavel'" class="form-control" [(ngModel)]="formularioValoresNovo[campo.id]" (ngModelChange)="campoFormularioAlterado(campo)" [disabled]="bloquearEdicaoVendedorResponsavel()">
            <option *ngFor="let seller of sellers" [ngValue]="seller.id">{{ seller.fullname }}</option>
          </select>

          <input *ngSwitchCase="'data_fechamento_prevista'" class="form-control" type="date" [(ngModel)]="formularioValoresNovo[campo.id]" (ngModelChange)="campoFormularioAlterado(campo)" />

          <ng-container *ngSwitchDefault>
            <input *ngIf="campo.tipo === 'DECIMAL' || campo.tipo === 'INTEIRO'" class="form-control" type="number" [(ngModel)]="formularioValoresNovo[campo.id]" (ngModelChange)="campoFormularioAlterado(campo)" [placeholder]="campo.placeholder" />
            <input *ngIf="campo.tipo === 'DATA'" class="form-control" type="date" [(ngModel)]="formularioValoresNovo[campo.id]" (ngModelChange)="campoFormularioAlterado(campo)" />
            <input *ngIf="campo.tipo === 'EMAIL'" class="form-control" type="email" [(ngModel)]="formularioValoresNovo[campo.id]" [placeholder]="campo.placeholder" />
            <input *ngIf="campo.tipo === 'TELEFONE'" class="form-control" [(ngModel)]="formularioValoresNovo[campo.id]" [placeholder]="campo.placeholder" />
            <div *ngIf="campo.tipo === 'PRODUTO'" class="product-search-control">
              <div class="client-search-row">
                <input class="form-control" [(ngModel)]="buscaProdutoNovo[campo.id]" (keyup.enter)="buscarProdutosNovo(campo)" [placeholder]="campo.placeholder || 'Buscar produto por descricao ou COD ERP'" />
                <button type="button" class="btn btn-primary" (click)="buscarProdutosNovo(campo)">Buscar</button>
              </div>

              <div class="client-box mt-2 product-selected-box" *ngIf="formularioValoresNovo[campo.id]">
                <div class="client-box-header">
                  <div>
                    <small>Produto selecionado</small>
                    <strong>{{ produtoSelecionadoTextoNovo(campo) }}</strong>
                  </div>
                  <button type="button" class="btn btn-outline-secondary btn-sm" (click)="limparProdutoNovo(campo)">Limpar</button>
                </div>
              </div>

              <div class="search-results" *ngIf="produtosNovo[campo.id]?.length">
                <button type="button" *ngFor="let produto of produtosNovo[campo.id]" (click)="selecionarProdutoNovo(campo, produto)">
                  <strong>{{ produto.name }}</strong>
                  <small *ngIf="produto.id_no_erp_do_cliente">COD ERP: {{ produto.id_no_erp_do_cliente }}</small>
                </button>
              </div>
            </div>
            <select *ngIf="campo.tipo === 'ALTERNATIVA'" class="form-control" [(ngModel)]="formularioValoresNovo[campo.id]">
              <option [ngValue]="null">Selecione...</option>
              <option *ngFor="let opcao of campo.opcoes" [ngValue]="opcao.id">{{ opcao.nome }}</option>
            </select>
            <div *ngIf="campo.tipo === 'ARQUIVO'" class="form-file-control">
              <input type="file" (change)="selecionarArquivoNovo($event, campo)" />
              <div class="file-item file-item-compact" *ngIf="nomeArquivoPendenteNovo(campo)">
                <div class="file-info">
                  <span>{{ nomeArquivoPendenteNovo(campo) }}</span>
                  <small>Aguardando criacao do card</small>
                </div>
                <div class="file-actions">
                  <button class="btn btn-sm btn-outline-primary" type="button" (click)="abrirArquivoPendenteNovo(campo)">Abrir</button>
                  <button class="btn btn-sm btn-outline-danger" type="button" (click)="removerArquivoNovo(campo)">Excluir</button>
                </div>
              </div>
            </div>
            <textarea *ngIf="campo.tipo === 'TEXTO'" class="form-control" rows="2" [(ngModel)]="formularioValoresNovo[campo.id]" (ngModelChange)="campoFormularioAlterado(campo)" [placeholder]="campo.placeholder"></textarea>
          </ng-container>
        </ng-container>

        <small class="field-help" *ngIf="campo.texto_ajuda">{{ campo.texto_ajuda }}</small>
      </div>
    </div>

    <div class="form-group" *ngIf="!novo.formulario_tipo_id">
      <label>Nome do negocio</label>
      <input class="form-control" [(ngModel)]="novo.nome_negocio" maxlength="200" />
    </div>

    <div class="form-group" *ngIf="!novo.formulario_tipo_id">
      <label>Cliente</label>
      <div class="client-search-row">
        <input
          class="form-control"
          [(ngModel)]="buscaCliente"
          (keyup.enter)="buscarClientes()"
          placeholder="Buscar por nome, fantasia, documento ou ERP" />
        <button type="button" class="btn btn-primary" (click)="buscarClientes()">Buscar</button>
      </div>
    </div>

    <div class="client-box" *ngIf="novo.client_id && !novo.formulario_tipo_id">
      <div class="client-box-header">
        <div>
          <small>Cliente selecionado</small>
          <strong>{{ novo.cliente_nome }}</strong>
        </div>
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="trocarClienteSelecionado()">Trocar cliente</button>
      </div>
      <div class="grid-2">
        <label>Responsavel<input class="form-control" [(ngModel)]="novo.responsible_name" /></label>
        <label>Contato Call Center<input class="form-control" [(ngModel)]="novo.contato_callcenter" /></label>
        <label>Telefone<input class="form-control" [(ngModel)]="novo.phone" /></label>
        <label>Telefone 2<input class="form-control" [(ngModel)]="novo.fone_02" /></label>
        <label>Telefone 3<input class="form-control" [(ngModel)]="novo.fone_03" /></label>
        <label>WhatsApp DDD<input class="form-control" [(ngModel)]="novo.fone_whatss_ddd" /></label>
        <label>WhatsApp<input class="form-control" [(ngModel)]="novo.fone_whatss" /></label>
      </div>
    </div>

    <div class="grid-2" *ngIf="!novo.formulario_tipo_id">
      <label>Valor<input class="form-control" type="number" [(ngModel)]="novo.valor_negociacao" /></label>
      <label>Fechamento<input class="form-control" type="date" [(ngModel)]="novo.data_fechamento_prevista" /></label>
      <label>Canal de origem<input class="form-control" [(ngModel)]="novo.canal_origem" /></label>
    </div>

    <div class="form-group">
      <label>Etapa</label>
      <select class="form-control" [(ngModel)]="novo.etapa_id">
        <option *ngFor="let etapa of departamentoSelecionado.etapas" [ngValue]="etapa.id">{{ etapa.nome }}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="!novo.formulario_tipo_id">
      <label>Vendedor responsavel</label>
      <select class="form-control" [(ngModel)]="novo.seller_id_responsavel" [disabled]="bloquearEdicaoVendedorResponsavel()">
        <option *ngFor="let seller of sellers" [ngValue]="seller.id">{{ seller.fullname }}</option>
      </select>
    </div>

    <button class="btn btn-success btn-block" (click)="criarCard()">Criar Card</button>

    <div class="kanban-modal-backdrop" *ngIf="clienteBuscaAberta">
      <div class="kanban-modal">
        <div class="kanban-modal-header">
          <div>
            <h3>Selecionar cliente</h3>
            <p>Escolha o cliente correto para vincular ao card.</p>
          </div>
          <button type="button" class="close-button" (click)="fecharBuscaClientes()">x</button>
        </div>

        <div class="client-result-list" *ngIf="clientes.length > 0; else semClientes">
          <button type="button" *ngFor="let cliente of clientes" (click)="selecionarCliente(cliente)">
            <strong>{{ cliente.name }}</strong>
            <span *ngIf="cliente.codigo_no_erp_do_cliente">ERP: {{ cliente.codigo_no_erp_do_cliente }}</span>
            <small>
              {{ cliente.fantasia || 'Sem fantasia' }}
              <span *ngIf="cliente.client_document"> | Doc: {{ cliente.client_document }}</span>
            </small>
          </button>
        </div>

        <ng-template #semClientes>
          <div class="kanban-empty compact-empty">
            Nenhum cliente encontrado. Ajuste o termo e clique em Buscar novamente.
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="kanban-modal-backdrop" *ngIf="importacaoAberta">
    <div class="kanban-modal kanban-import-modal">
      <div class="kanban-modal-header">
        <div>
          <h3>Importar cards via Excel</h3>
          <p>Selecione a etapa, o formulario e a planilha com os campos padrao e extras do formulario.</p>
        </div>
        <button type="button" class="close-button" (click)="fecharImportacao()">x</button>
      </div>

      <div class="import-grid">
        <label>
          Etapa
          <select class="form-control" [(ngModel)]="importacao.etapa_id">
            <option [ngValue]="null">Selecione...</option>
            <option *ngFor="let etapa of etapasImportacao()" [ngValue]="etapa.id">{{ etapa.nome }}</option>
          </select>
        </label>

        <label>
          Formulario
          <select class="form-control" [(ngModel)]="importacao.formulario_tipo_id">
            <option [ngValue]="null">Selecione...</option>
            <option *ngFor="let formulario of formulariosDoDepartamento()" [ngValue]="formulario.id">{{ formulario.nome }}</option>
          </select>
        </label>
      </div>

      <div class="import-template-box">
        <div>
          <strong>Planilha modelo</strong>
          <span>Colunas: {{ colunasModeloImportacao().join(', ') }}</span>
        </div>
        <button type="button" class="btn btn-outline-primary" (click)="baixarModeloImportacao()">Baixar modelo</button>
      </div>

      <label class="import-file-box">
        Arquivo
        <input class="form-control" type="file" accept=".xlsx,.csv" (change)="selecionarArquivoImportacao($event)" />
      </label>

      <div class="import-result" *ngIf="resultadoImportacao">
        <strong>{{ resultadoImportacao.importados }} de {{ resultadoImportacao.total_linhas }} linha(s) importada(s)</strong>
        <ul *ngIf="resultadoImportacao.erros && resultadoImportacao.erros.length">
          <li *ngFor="let erro of resultadoImportacao.erros">{{ erro }}</li>
        </ul>
      </div>

      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="fecharImportacao()" [disabled]="importando">Cancelar</button>
        <button type="button" class="btn btn-success" (click)="importarCards()" [disabled]="importando">
          {{ importando ? 'Importando...' : 'Importar' }}
        </button>
      </div>
    </div>
  </div>

  <div class="side-panel detail-panel" *ngIf="detalhe && detalhe.negocio" [attr.aria-busy]="carregandoDetalhe" [attr.inert]="carregandoDetalhe ? '' : null">
    <nav class="detail-card-navigation" aria-label="Navegar entre cards da mesma etapa" *ngIf="indiceCardDetalhe >= 0">
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="navegarCardEtapa(-1)" [disabled]="carregandoDetalhe || indiceCardDetalhe === 0">← Anterior</button>
      <span aria-live="polite">{{ carregandoDetalhe ? 'Carregando…' : (indiceCardDetalhe + 1) + ' de ' + cardsEtapaDetalhe.length }} · {{ detalhe.negocio.etapa_nome }}</span>
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="navegarCardEtapa(1)" [disabled]="carregandoDetalhe || indiceCardDetalhe >= cardsEtapaDetalhe.length - 1">Próximo →</button>
    </nav>
    <div class="side-panel-header">
      <h2>{{ detalhe.negocio.nome_negocio }}</h2>
      <div class="detail-header-actions">
        <button type="button" class="btn btn-outline-danger" *ngIf="podeInativarCard()" (click)="inativarCard()">Inativar</button>
        <button type="button" class="btn btn-primary" (click)="salvarCardDetalhe()">Salvar</button>
        <button type="button" class="close-button" (click)="fecharDetalhe()">x</button>
      </div>
    </div>

    <div class="deal-summary-strip">
      <span>Responsavel: {{ detalhe.negocio.seller_responsavel_nome }}</span>
      <span>Status: {{ detalhe.negocio.status }}</span>
      <span>Etapa: {{ detalhe.negocio.etapa_nome }}</span>
    </div>

    <div class="detail-actions top-actions">
      <button class="btn btn-outline-primary" (click)="abrirLigacao()">Ligacao</button>
      <button class="btn btn-outline-secondary" (click)="abrirAnalise()">Analise</button>
      <button class="btn btn-outline-info" (click)="abrirPedido()">Pedido</button>
      <button class="btn btn-outline-success" (click)="abrirWhatsApp()">WhatsApp</button>
      <button class="btn btn-success" (click)="ganhar()">Ganho</button>
      <button class="btn btn-outline-danger" (click)="abrirPerda()">Perda</button>
    </div>

    <div class="form-group move-stage-top">
      <label>Mover etapa</label>
      <select class="form-control" [ngModel]="detalhe.negocio.etapa_id" (ngModelChange)="mover(detalhe.negocio, $event)">
        <option *ngFor="let etapa of etapasDepartamento(detalhe.negocio.departamento_id)" [ngValue]="etapa.id">{{ etapa.nome }}</option>
      </select>
    </div>

    <div class="scheduled-call-box" *ngIf="detalhe.negocio.ligacao_agendada_id">
      <div>
        <strong>Ligacao agendada para hoje</strong>
        <span>{{ detalhe.negocio.ligacao_agendada_data | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>
      <button type="button" class="btn btn-primary" (click)="abrirLigacaoAgendada()">Fazer ligacao</button>
    </div>

    <div class="form-type-tag detail-form-tag" *ngIf="detalhe.negocio.formulario_tipo_nome">
      {{ detalhe.negocio.formulario_tipo_nome }}
    </div>

    <div class="detail-section" *ngIf="detalhe.negocio.formulario_tipo_id">
      <h3>Informacoes do formulario</h3>

      <div class="dynamic-form detail-dynamic-form">
        <div class="form-group" *ngFor="let campo of camposDetalhe()">
          <label>{{ campo.nome }} <span *ngIf="campo.obrigatorio">*</span></label>

          <ng-container [ngSwitch]="campo.chave">
            <input *ngSwitchCase="'nome_negocio'" class="form-control" [(ngModel)]="formularioValoresDetalhe[campo.id]" (ngModelChange)="campoDetalheAlterado(campo)" maxlength="200" />

            <div *ngSwitchCase="'client_id'">
              <div class="client-search-row">
                <input class="form-control" [(ngModel)]="buscaClienteDetalhe" (keyup.enter)="buscarClientesDetalhe()" [placeholder]="campo.placeholder || 'Buscar outro cliente'" />
                <button type="button" class="btn btn-primary" (click)="buscarClientesDetalhe()">Buscar</button>
              </div>

              <div class="client-box mt-2" *ngIf="clienteDetalheEdicao && clienteDetalheEdicao.client_id">
                <div class="client-box-header">
                  <div>
                    <small>Cliente selecionado</small>
                    <strong>{{ clienteDetalheEdicao.name || detalhe.negocio.cliente_nome }}</strong>
                    <span *ngIf="clienteDetalheEdicao.codigo_no_erp_do_cliente">ERP: {{ clienteDetalheEdicao.codigo_no_erp_do_cliente }}</span>
                  </div>
                  <small class="autosave-hint">Salvo automaticamente</small>
                </div>
              </div>
            </div>

            <select *ngSwitchCase="'seller_id_responsavel'" class="form-control" [(ngModel)]="formularioValoresDetalhe[campo.id]" (ngModelChange)="campoDetalheAlterado(campo)" [disabled]="bloquearEdicaoVendedorResponsavel()">
              <option *ngFor="let seller of sellersDetalhe" [ngValue]="seller.id">{{ seller.fullname }}</option>
            </select>

            <input *ngSwitchCase="'data_fechamento_prevista'" class="form-control" type="date" [(ngModel)]="formularioValoresDetalhe[campo.id]" (ngModelChange)="campoDetalheAlterado(campo)" />

            <ng-container *ngSwitchDefault>
              <input *ngIf="campo.tipo === 'DECIMAL' || campo.tipo === 'INTEIRO'" class="form-control" type="number" [(ngModel)]="formularioValoresDetalhe[campo.id]" (ngModelChange)="campoDetalheAlterado(campo)" [placeholder]="campo.placeholder" />
              <input *ngIf="campo.tipo === 'DATA'" class="form-control" type="date" [(ngModel)]="formularioValoresDetalhe[campo.id]" />
              <input *ngIf="campo.tipo === 'EMAIL'" class="form-control" type="email" [(ngModel)]="formularioValoresDetalhe[campo.id]" [placeholder]="campo.placeholder" />
              <input *ngIf="campo.tipo === 'TELEFONE'" class="form-control" [(ngModel)]="formularioValoresDetalhe[campo.id]" [placeholder]="campo.placeholder" />
              <div *ngIf="campo.tipo === 'PRODUTO'" class="product-search-control">
                <div class="client-search-row">
                  <input class="form-control" [(ngModel)]="buscaProdutoDetalhe[campo.id]" (keyup.enter)="buscarProdutosDetalhe(campo)" [placeholder]="campo.placeholder || 'Buscar produto por descricao ou COD ERP'" />
                  <button type="button" class="btn btn-primary" (click)="buscarProdutosDetalhe(campo)">Buscar</button>
                </div>

                <div class="client-box mt-2 product-selected-box" *ngIf="formularioValoresDetalhe[campo.id]">
                  <div class="client-box-header">
                    <div>
                      <small>Produto selecionado</small>
                      <strong>{{ produtoSelecionadoTextoDetalhe(campo) }}</strong>
                    </div>
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="limparProdutoDetalhe(campo)">Limpar</button>
                  </div>
                </div>

                <div class="search-results" *ngIf="produtosDetalhe[campo.id]?.length">
                  <button type="button" *ngFor="let produto of produtosDetalhe[campo.id]" (click)="selecionarProdutoDetalhe(campo, produto)">
                    <strong>{{ produto.name }}</strong>
                    <small *ngIf="produto.id_no_erp_do_cliente">COD ERP: {{ produto.id_no_erp_do_cliente }}</small>
                  </button>
                </div>
              </div>
              <select *ngIf="campo.tipo === 'ALTERNATIVA'" class="form-control" [(ngModel)]="formularioValoresDetalhe[campo.id]">
                <option [ngValue]="null">Selecione...</option>
                <option *ngFor="let opcao of campo.opcoes" [ngValue]="opcao.id">{{ opcao.nome }}</option>
              </select>
              <div *ngIf="campo.tipo === 'ARQUIVO'" class="form-file-control">
                <input type="file" (change)="anexarArquivoCampoDetalhe($event, campo)" />
                <div class="file-item file-item-compact" *ngIf="arquivoCampoDetalhe(campo) as arquivo">
                  <div class="file-info">
                    <span>{{ arquivo.nome_original }}</span>
                    <small>{{ arquivo.data_criacao | date:'dd/MM/yyyy HH:mm' }}</small>
                  </div>
                  <div class="file-actions">
                    <button class="btn btn-sm btn-outline-primary" type="button" (click)="abrirArquivo(arquivo)">Abrir</button>
                    <button class="btn btn-sm btn-outline-primary" type="button" (click)="baixarArquivo(arquivo)">Baixar</button>
                    <button class="btn btn-sm btn-outline-danger" type="button" (click)="excluirArquivoCampoDetalhe(campo)">Excluir</button>
                  </div>
                </div>
              </div>
              <textarea *ngIf="campo.tipo === 'TEXTO'" class="form-control" rows="2" [(ngModel)]="formularioValoresDetalhe[campo.id]" (ngModelChange)="campoDetalheAlterado(campo)" [placeholder]="campo.placeholder"></textarea>
            </ng-container>
          </ng-container>
        </div>
      </div>

    </div>

    <div class="detail-section" *ngIf="!detalhe.negocio.formulario_tipo_id">
      <label>Nome do negocio</label>
      <div class="inline-edit">
        <input class="form-control" [(ngModel)]="nomeNegocioEdicao" maxlength="200" />
      </div>
    </div>

    <div class="detail-section" *ngIf="!detalhe.negocio.formulario_tipo_id">
      <label>Informacoes do negocio</label>
      <div class="deal-info-edit">
        <label class="deal-info-value">Valor<input class="form-control" type="number" [(ngModel)]="valorNegocioEdicao" /></label>
        <label class="deal-info-date">Data fechamento<input class="form-control" type="date" [(ngModel)]="dataFechamentoEdicao" /></label>
        <label class="deal-info-channel">Canal de origem<input class="form-control" [(ngModel)]="canalOrigemEdicao" maxlength="100" /></label>
        <label class="deal-info-seller">Vendedor responsavel
          <select class="form-control" [(ngModel)]="sellerResponsavelEdicao" [disabled]="bloquearEdicaoVendedorResponsavel()">
            <option *ngFor="let seller of sellersDetalhe" [ngValue]="seller.id">{{ seller.fullname }}</option>
          </select>
        </label>
      </div>
      <div class="deal-close-tag mt-2" *ngIf="detalhe.negocio.data_fechamento_prevista" [ngClass]="classeFechamento(detalhe.negocio)">
        {{ textoFechamento(detalhe.negocio) }}
      </div>
    </div>

    <div class="detail-section" *ngIf="!detalhe.negocio.formulario_tipo_id">
      <label>Cliente do negocio</label>
      <div class="client-search-row">
        <input
          class="form-control"
          [(ngModel)]="buscaClienteDetalhe"
          (keyup.enter)="buscarClientesDetalhe()"
          placeholder="Buscar outro cliente por nome, fantasia, documento ou ERP" />
        <button type="button" class="btn btn-primary" (click)="buscarClientesDetalhe()">Buscar</button>
      </div>

      <div class="client-box mt-2" *ngIf="clienteDetalheEdicao && clienteDetalheEdicao.client_id">
        <div class="client-box-header">
          <div>
            <small>Cliente selecionado</small>
            <strong>{{ clienteDetalheEdicao.name || detalhe.negocio.cliente_nome }}</strong>
            <span *ngIf="clienteDetalheEdicao.codigo_no_erp_do_cliente">ERP: {{ clienteDetalheEdicao.codigo_no_erp_do_cliente }}</span>
          </div>
          <small class="autosave-hint">Salvo automaticamente</small>
        </div>

        <div class="grid-2">
          <label>Responsavel<input class="form-control" [(ngModel)]="clienteDetalheEdicao.responsible_name" (ngModelChange)="agendarSalvarClienteDetalhe()" /></label>
          <label>Contato Call Center<input class="form-control" [(ngModel)]="clienteDetalheEdicao.contato_callcenter" (ngModelChange)="agendarSalvarClienteDetalhe()" /></label>
          <label>Telefone<input class="form-control" [(ngModel)]="clienteDetalheEdicao.phone" (ngModelChange)="agendarSalvarClienteDetalhe()" /></label>
          <label>Telefone 2<input class="form-control" [(ngModel)]="clienteDetalheEdicao.fone_02" (ngModelChange)="agendarSalvarClienteDetalhe()" /></label>
          <label>Telefone 3<input class="form-control" [(ngModel)]="clienteDetalheEdicao.fone_03" (ngModelChange)="agendarSalvarClienteDetalhe()" /></label>
          <label>WhatsApp DDD<input class="form-control" [(ngModel)]="clienteDetalheEdicao.fone_whatss_ddd" (ngModelChange)="agendarSalvarClienteDetalhe()" /></label>
          <label>WhatsApp<input class="form-control" [(ngModel)]="clienteDetalheEdicao.fone_whatss" (ngModelChange)="agendarSalvarClienteDetalhe()" /></label>
        </div>
      </div>

      <div class="kanban-modal-backdrop" *ngIf="clienteDetalheBuscaAberta">
        <div class="kanban-modal">
          <div class="kanban-modal-header">
            <div>
              <h3>Selecionar cliente</h3>
              <p>Escolha o novo cliente que sera vinculado ao negocio.</p>
            </div>
            <button type="button" class="close-button" (click)="fecharBuscaClientesDetalhe()">x</button>
          </div>

          <div class="client-result-list" *ngIf="clientes.length > 0; else semClientesDetalhe">
            <button type="button" *ngFor="let cliente of clientes" (click)="selecionarClienteDetalhe(cliente)">
              <strong>{{ cliente.name }}</strong>
              <span *ngIf="cliente.codigo_no_erp_do_cliente">ERP: {{ cliente.codigo_no_erp_do_cliente }}</span>
              <small>
                {{ cliente.fantasia || 'Sem fantasia' }}
                <span *ngIf="cliente.client_document"> | Doc: {{ cliente.client_document }}</span>
              </small>
            </button>
          </div>

          <ng-template #semClientesDetalhe>
            <div class="kanban-empty compact-empty">
              Nenhum cliente encontrado. Ajuste o termo e clique em Buscar novamente.
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="loss-summary" *ngIf="detalhe.negocio.status === 'PERDIDO' || detalhe.negocio.motivo_perda_nome || detalhe.negocio.observacao_perda">
      <strong>Motivo da perda</strong>
      <p *ngIf="detalhe.negocio.motivo_perda_nome">{{ detalhe.negocio.motivo_perda_nome }}</p>
      <small *ngIf="detalhe.negocio.observacao_perda">{{ detalhe.negocio.observacao_perda }}</small>
    </div>

    <div class="loss-box" *ngIf="perdaAberta">
      <label *ngIf="etapasFinalizacao('PERDA').length > 1">Etapa de perda</label>
      <select class="form-control mb-2" *ngIf="etapasFinalizacao('PERDA').length > 1" [(ngModel)]="perda.etapa_id">
        <option [ngValue]="null">Selecione...</option>
        <option *ngFor="let etapa of etapasFinalizacao('PERDA')" [ngValue]="etapa.id">{{ etapa.nome }}</option>
      </select>
      <label>Motivo da perda</label>
      <select class="form-control" [(ngModel)]="perda.motivo_id">
        <option [ngValue]="null">Selecione...</option>
        <option *ngFor="let motivo of motivosPerda" [ngValue]="motivo.id">{{ motivo.name }}</option>
      </select>
      <textarea class="form-control mt-2" rows="3" [(ngModel)]="perda.observacao" placeholder="Complemento do motivo"></textarea>
      <button class="btn btn-danger btn-block mt-2" (click)="confirmarPerda()">Confirmar Perda</button>
    </div>

    <div class="detail-section">
      <h3>Anotacoes</h3>
      <textarea class="form-control" rows="3" [(ngModel)]="novaAnotacao" placeholder="Escreva uma anotacao"></textarea>
      <button class="btn btn-primary btn-sm mt-2" (click)="adicionarAnotacao()">Adicionar</button>
      <div class="timeline-item" *ngFor="let anotacao of detalhe.anotacoes">
        <strong>{{ anotacao.seller_nome }}</strong>
        <span>{{ anotacao.data_criacao | date:'dd/MM/yyyy HH:mm' }}</span>
        <p *ngIf="anotacaoEditandoId !== anotacao.id">{{ anotacao.anotacao }}</p>
        <textarea *ngIf="anotacaoEditandoId === anotacao.id" class="form-control" rows="3" [(ngModel)]="anotacaoEditandoTexto"></textarea>
        <div class="note-actions" *ngIf="anotacaoEditandoId !== anotacao.id">
          <button class="btn btn-outline-primary btn-sm" (click)="editarAnotacao(anotacao)">Editar</button>
        </div>
        <div class="note-actions" *ngIf="anotacaoEditandoId === anotacao.id">
          <button class="btn btn-primary btn-sm" (click)="salvarAnotacao(anotacao)">Salvar</button>
          <button class="btn btn-outline-secondary btn-sm" (click)="cancelarEdicaoAnotacao()">Cancelar</button>
        </div>
      </div>
    </div>

    <div class="detail-section">
      <h3>Arquivos</h3>
      <input type="file" (change)="anexarArquivo($event)" />
      <div class="file-item" *ngFor="let arquivo of detalhe.arquivos">
        <div class="file-info">
          <span>{{ arquivo.nome_original }}</span>
          <small>{{ arquivo.data_criacao | date:'dd/MM/yyyy HH:mm' }}</small>
        </div>
        <div class="file-actions">
          <button class="btn btn-sm btn-outline-primary" type="button" (click)="abrirArquivo(arquivo)">Abrir</button>
                    <button class="btn btn-sm btn-outline-primary" type="button" (click)="baixarArquivo(arquivo)">Baixar</button>
          <button class="btn btn-sm btn-outline-danger" type="button" (click)="excluirArquivo(arquivo)">Excluir</button>
        </div>
      </div>
    </div>
  </div>

  <div class="kanban-modal-backdrop" *ngIf="ganhoEtapaAberta">
    <div class="kanban-modal kanban-final-stage-modal">
      <div class="kanban-modal-header">
        <div>
          <h3>Selecionar etapa de ganho</h3>
          <p>Existe mais de uma etapa configurada como ganho. Escolha para onde o card deve ir.</p>
        </div>
        <button type="button" class="close-button" (click)="fecharSelecaoGanho()">x</button>
      </div>

      <label>Etapa de ganho</label>
      <select class="form-control" [(ngModel)]="etapaGanhoSelecionadaId">
        <option [ngValue]="null">Selecione...</option>
        <option *ngFor="let etapa of etapasFinalizacao('GANHO')" [ngValue]="etapa.id">{{ etapa.nome }}</option>
      </select>

      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="fecharSelecaoGanho()">Cancelar</button>
        <button type="button" class="btn btn-success" (click)="confirmarGanho()">Confirmar ganho</button>
      </div>
    </div>
  </div>
  </ng-container>

  <ng-template #kanbanDisabled>
    <section class="kanban-disabled-hero">
      <div class="kanban-disabled-copy">
        <span class="kanban-disabled-badge">Novo modulo</span>
        <h1>CRM Napis</h1>
        <p class="kanban-disabled-lead">
          Organize oportunidades, atendimentos e tarefas por etapas, com acompanhamento visual do funil e historico completo do cliente.
        </p>
        <div class="kanban-disabled-alert">
          Esta funcao ainda nao esta habilitada para o seu usuario. Entre em contato com o suporte para agendar uma apresentacao.
        </div>
      </div>

      <div class="kanban-preview-board" aria-hidden="true">
        <div class="preview-column">
          <div class="preview-title">Aberto</div>
          <div class="preview-card">
            <strong>Novo negocio</strong>
            <span>Cliente identificado</span>
            <small>Fecha em 5 dias</small>
          </div>
        </div>
        <div class="preview-column">
          <div class="preview-title">Atendimento</div>
          <div class="preview-card accent">
            <strong>Proposta enviada</strong>
            <span>Anotacoes e arquivos</span>
            <small>R$ 12.500,00</small>
          </div>
        </div>
        <div class="preview-column">
          <div class="preview-title">Ganho</div>
          <div class="preview-card success">
            <strong>Venda concluida</strong>
            <span>Pedido vinculado</span>
            <small>Atualizado automaticamente</small>
          </div>
        </div>
      </div>
    </section>

    <section class="kanban-feature-grid">
      <article>
        <span>01</span>
        <h3>Funis por departamento</h3>
        <p>Separe comercial, financeiro, help desk ou qualquer outro fluxo com etapas e formularios proprios.</p>
      </article>
      <article>
        <span>02</span>
        <h3>Cards com cliente e vendedor</h3>
        <p>Vincule cliente, responsavel, valor, previsao de fechamento, origem e informacoes especificas do formulario.</p>
      </article>
      <article>
        <span>03</span>
        <h3>Acoes no contexto</h3>
        <p>Abra ligacao, analise, pedido, WhatsApp e arquivos sem perder o historico do negocio.</p>
      </article>
      <article>
        <span>04</span>
        <h3>Gestao visual</h3>
        <p>Acompanhe prazos, motivos de perda, negocios ganhos e movimentacao por arrastar e soltar.</p>
      </article>
    </section>
  </ng-template>
</div>
